import React, { useState, useEffect } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Toolbar,
  Input,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Typography,
  TextField,
  Snackbar,
  Alert
} from '@mui/material';
import { FaUserEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { useSelector } from 'react-redux';
import apiConfig from '../../config/api.js';

const style = {
  width: 450,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '8px',
  padding: '20px',
};

const TemplatesComponent = ({ templates, fetchTemplates }) => {
  const isLang = useSelector((state) => state.authReducer.lang);
  const [editMode, setEditMode] = useState(false); 
  const [filteredCategories, setFilteredCategories] = useState(templates);
  const [searchInput, setSearchInput] = useState('');
  const [debouncedSearchInput, setDebouncedSearchInput] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null); // For edit functionality
  const [deleteConfirmation, setDeleteConfirmation] = useState({
    open: false,
    id: null,
  });

  // Edit modal open state
  const [category, setCategory] = useState('');
  const [packageType, setPackageType] = useState('');
  const [title, setTitle] = useState('');
  const [uploadedBy, setUploadedBy] = useState('1');
  const [amount, setAmount] = useState('');
  const [status, setStatus] = useState('Active');
  const [tempAmount, setTempAmount] = useState(''); // Added temp_amount state
  const [comment, setComment] = useState('')
  const [categories, setCategories] = useState([]);
  const [packages, setPackages] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarDelete, setSnackbarDelete] = useState(false);
  const [snackbarEdit, setSnackbarEdit] = useState(false);
  const [snackbarPackageError, setSnackbarPackageError] = useState(false);
  const [loading, setLoading] = useState(false); // Added loading state

  useEffect(() => {
    setFilteredCategories(templates);
    console.log("Template are: ",templates);
  }, [templates]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchInput(searchInput);
    }, 300);
    return () => clearTimeout(handler);
  }, [searchInput]);

  const handleSearchInputChange = (e) => setSearchInput(e.target.value);

  useEffect(() => {
    const filtered = templates.filter((item) => {
      return (
        item.title.toLowerCase().includes(debouncedSearchInput.toLowerCase()) ||
        item.pkgtitle.toLowerCase().includes(debouncedSearchInput.toLowerCase()) ||
        item.cattitle.toLowerCase().includes(debouncedSearchInput.toLowerCase())
      );
    });
    setFilteredCategories(filtered);
  }, [debouncedSearchInput, templates]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${apiConfig.API_URL}/aapi/getcategories.php`);
        if (!response.ok) {
          throw new Error('Failed to fetch categories');
        }
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error('Error fetching categories:', error.message);
      }
    };

    const fetchPackages = async () => {
      try {
        const response = await fetch(`${apiConfig.API_URL}/aapi/getPackages.php`);
        if (!response.ok) {
          throw new Error('Failed to fetch packages');
        }
        const data = await response.json();
        setPackages(data);
      } catch (error) {
        console.error('Error fetching packages:', error.message);
      }
    };

    fetchCategories();
    fetchPackages();
  
  }, []);

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Function to handle category selection and automatically set the amount
  const handleCategoryChange = (e) => {
    const selectedCategoryId = e.target.value;
    setCategory(selectedCategoryId);

    // Find the selected category's details from the categories array
    const selectedCategory = categories.find((item) => item.id === selectedCategoryId);

    // If the selected category is found, set the amount to its amount
    if (selectedCategory) {
      setAmount(selectedCategory.amount);
    }
  };

  const handleFormUpdate = async (e) => {
    e.preventDefault();
    // Check if all required fields are filled
    if (!category || !packageType || !title || !amount) {
      setSnackbarPackageError(true); // Show error snackbar if validation fails
      return;
    }
  
    try {
      setLoading(true);
      const formDataToSend = new FormData();
      formDataToSend.append('id', selectedRowData.id); // Add the ID of the template
      formDataToSend.append('category', category);
      formDataToSend.append('pkgid', packageType);
      formDataToSend.append('title', title);
      formDataToSend.append('amount', amount);
console.log("Form Data: ",selectedRowData.id,category,packageType,title,amount);
  
      const response = await fetch(`${apiConfig.API_URL}/aapi/developer_api/uploadtemplete.php`, {
        method: 'POST',
        body: formDataToSend,
      });
  
      if (response.ok) {
        setSnackbarEdit(true);
        setOpenDialog(false);
        await fetchTemplates(); // Refresh templates
      } else {
        console.error('Failed to save the updated template.');
      }
    } catch (error) {
      console.error('Error saving template:', error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateData = (row) => {
    setSelectedRowData(row);
    setCategory(row.category);
    setPackageType(row.pkgid);
    setTitle(row.title);
    setComment(row.comments);
    setAmount(row.amount);
    setTempAmount(row.temp_amount); 
    setStatus(row.status);
    setOpenDialog(true); 
    setEditMode(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedRowData(null);
  };

  const handleDelete = (row) => {
    setDeleteConfirmation({ open: true, id: row.id });
  };

  const handleConfirmDelete = async () => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('id', deleteConfirmation.id);
      const response = await fetch(`${apiConfig.API_URL}/aapi/delete_templete.php`, {
        method: 'POST',
        body: formDataToSend,
      });

      if (response.ok) {
        setSnackbarDelete(true);
        await fetchTemplates(); // Refresh templates
      } else {
        console.error('Failed to delete category');
      }
    }
   catch (error) {
      console.error('Error deleting category:', error.message);
    } finally {
      setDeleteConfirmation({ open: false, id: null });
    }
  };

  const handleCancelDelete = () => {
    setDeleteConfirmation({ open: false, id: null });
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Toolbar>
          <Input
            value={searchInput}
            onChange={handleSearchInputChange}
            placeholder="Search for templates"
          />
        </Toolbar>
      </div>

      {/* Table */}
      <TableContainer component={Paper}>
        <Table>
        <TableHead>
  <TableRow>
    <TableCell>{isLang === 'eng' ? 'ID' : 'معرف'}</TableCell>
    <TableCell>{isLang === 'eng' ? 'Image' : 'صورة'}</TableCell>
    <TableCell>{isLang === 'eng' ? 'Title' : 'العنوان'}</TableCell>
    <TableCell>{isLang === 'eng' ? 'Package' : 'الحزمة'}</TableCell>
    <TableCell>{isLang === 'eng' ? 'Category' : 'الفئة'}</TableCell>
    <TableCell>{isLang === 'eng' ? 'Amount' : 'المبلغ'}</TableCell>
    <TableCell>{isLang === 'eng' ? 'Status' : 'الحالة'}</TableCell>
    <TableCell>{isLang === 'eng' ? 'Comments' : 'تعليقات'}</TableCell>
    <TableCell>{isLang === 'eng' ? 'Updated At' : 'تم التحديث في'}</TableCell>
    <TableCell>{isLang === 'eng' ? 'Action' : 'الإجراء'}</TableCell>
  </TableRow>
</TableHead>
          <TableBody>
            {filteredCategories
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>
                    <img
                      src={`${apiConfig.API_URL}/aapi/templetes/${row.imagepath}`}
                      alt="Image"
                      style={{ maxWidth: '50px', maxHeight: '50px' }}
                    />
                  </TableCell>
                  <TableCell>{row.title}</TableCell>
                  <TableCell>{row.pkgtitle}</TableCell>
                  <TableCell>{row.cattitle}</TableCell>
                  <TableCell>{row.amount}</TableCell>
                  <TableCell>{row.status}</TableCell>
                  <TableCell>{row.comments}</TableCell>
                  <TableCell>{row.updated_at}</TableCell>
                  <TableCell>
                    <div style={{ display: 'flex' }}>
                      <FaUserEdit onClick={() => handleUpdateData(row)} style={{ fontSize: '26px', color: '#006a5c', paddingRight: '6px', cursor: 'pointer' }} />
                      <MdDeleteForever onClick={() => handleDelete(row)} style={{ fontSize: '26px', color: '#b03f37', cursor: 'pointer' }} />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: filteredCategories.length }]}
        count={filteredCategories.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      {/* Edit Dialog */}
      <Dialog
  open={openDialog}
  onClose={handleDialogClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style}>
    <DialogTitle>
      <Typography variant="h6" component="h2">
        {editMode
          ? isLang === "arabic" 
            ? "تعديل القالب" 
            : "Edit Template"
          : isLang === "arabic"
            ? "إضافة قالب"
            : "Add Template"}
      </Typography>
    </DialogTitle>

    <DialogContent>
      <form onSubmit={handleFormUpdate}>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>
            {isLang === "arabic" ? "الفئة" : "Category"}
          </InputLabel>
          <Select
            value={category || ""}
            onChange={handleCategoryChange}
            required
          >
            {categories.length > 0 ? (
              categories.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.title}
                </MenuItem>
              ))
            ) : (
              <MenuItem value="">
                <em>{isLang === "arabic" ? "جار تحميل الفئات..." : "Loading Categories..."}</em>
              </MenuItem>
            )}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>
            {isLang === "arabic" ? "الحزم" : "Packages"}
          </InputLabel>
          <Select
            value={packageType || ""}
            onChange={(e) => setPackageType(e.target.value)}
            required
          >
            {packages.length > 0 ? (
              packages.map((packageItem) => (
                <MenuItem key={packageItem.id} value={packageItem.id}>
                  {packageItem.title}
                </MenuItem>
              ))
            ) : (
              <MenuItem value="">
                <em>{isLang === "arabic" ? "جار تحميل الحزم..." : "Loading Packages..."}</em>
              </MenuItem>
            )}
          </Select>
        </FormControl>

        <TextField
          label={isLang === "arabic" ? "العنوان" : "Title"}
          fullWidth
          sx={{ mt: 2 }}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <TextField
          label={isLang === "arabic" ? "المبلغ" : "Amount"}
          fullWidth
          sx={{ mt: 2 }}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          disabled
          required
        />
        <TextField
          label={isLang === "arabic" ? "التعليقات" : "Comments"}
          fullWidth
          sx={{ mt: 2 }}
          value={comment}
          disabled
          required
        />

        <DialogActions>
          <Button
            variant="contained"
            type="submit"
            sx={{ mt: 2 }}
            disabled={loading}
          >
            {editMode
              ? isLang === "arabic"
                ? "تحديث"
                : "Update"
              : isLang === "arabic"
                ? "حفظ"
                : "Save"}
          </Button>
        </DialogActions>
      </form>
      {loading && <div className="loader"></div>}
    </DialogContent>
  </Box>
</Dialog>

{/* Delete Confirmation Dialog */}
<Dialog open={deleteConfirmation.open} onClose={handleCancelDelete}>
  <DialogTitle>{isLang === "arabic" ? "تأكيد الحذف" : "Confirm Deletion"}</DialogTitle>
  <DialogContent>
    <Typography>{isLang === "arabic" ? "هل أنت متأكد أنك تريد حذف هذا القالب؟" : "Are you sure you want to delete this template?"}</Typography>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCancelDelete}>{isLang === "arabic" ? "إلغاء" : "Cancel"}</Button>
    <Button onClick={handleConfirmDelete}>{isLang === "arabic" ? "حذف" : "Delete"}</Button>
  </DialogActions>
</Dialog>

{/* Snackbars */}
<Snackbar open={snackbarDelete} autoHideDuration={5000} onClose={() => setSnackbarDelete(false)}>
  <Alert severity="success">
    {isLang === "arabic" ? "تم حذف القالب بنجاح." : "Template deleted successfully."}
  </Alert>
</Snackbar>

<Snackbar open={snackbarEdit} autoHideDuration={5000} onClose={() => setSnackbarEdit(false)}>
  <Alert severity="success">
    {isLang === "arabic" ? "تم تحديث القالب بنجاح." : "Template updated successfully."}
  </Alert>
</Snackbar>

<Snackbar open={snackbarPackageError} autoHideDuration={5000} onClose={() => setSnackbarPackageError(false)}>
  <Alert severity="error">
    {isLang === "arabic" ? "يرجى ملء جميع الحقول المطلوبة." : "Please fill in all required fields."}
  </Alert>
</Snackbar>

    </div>
  );
};

export default TemplatesComponent;
